// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2Up9F","productName":"Table_productName__1a7uB"};